import { takeLatest, put, call } from 'redux-saga/effects';
import get from 'lodash/get';
import { getMessageContentNew } from 'yoda-interfaces/lib/Content/ContentApi';
import { creditCardBannerConst } from '../helpers/ProductConstants';

import * as actionTypes from '../actionTypes/CreditCardBannerDataActionTypes';

function* creditCardBannerSaga(action) {
    try {
        const payload = {
            isChannelRequired: true,
            skipExtractUIContent: true,
            searchTerm: get(
                action,
                'payload.searchTerm',
                creditCardBannerConst.CREDIT_CARD_BANNER_TYPE
            ),
        };
        const imageContent = yield call(getMessageContentNew, { payload }, true);
        yield put({
            type: actionTypes.SET_CREDIT_CARD_BANNER_DATA,
            content: get(imageContent, '[0].content', {}),
        });
    } catch (error) {
        yield put({
            type: actionTypes.GET_CREDIT_CARD_BANNER_DATA_ERROR,
            errorHandlerInfo: error,
        });
    }
}

const watchCreditCardBannerSaga = function* watchCreditCardBannerSaga() {
    yield takeLatest(actionTypes.GET_CREDIT_CARD_BANNER_DATA, creditCardBannerSaga);
};
watchCreditCardBannerSaga.sagaName = 'watchCreditCardBannerSaga';

export default watchCreditCardBannerSaga;
